import { useMemo } from 'react'
import { Column } from './types'


export function useColumnTitles(currency: string = '₽') {
  const columns = useMemo(() => {
    return {
      [Column.Title]: 'Наименование',
      [Column.Date]: 'Дата и время',
      [Column.BalanceAtTheBeginning]: `Остаток на начало\u00A0дня,\u00A0${currency}`,
      [Column.Revenue]: `Выручка,\u00A0${currency}`,
      [Column.Collected]: `Сдано,\u00A0${currency}`,
      [Column.BalanceAtTheEnd]: `Остаток на конец\u00A0дня,\u00A0${currency}`,
      [Column.EncashmentsCount]: 'Кол-во инкассаций',
      [Column.Action]: 'Действие',
    }
  }, [currency])

  return columns
}
